import script from "./customer-select-checked.vue?vue&type=script&setup=true&lang=js"
export * from "./customer-select-checked.vue?vue&type=script&setup=true&lang=js"

import "./customer-select-checked.vue?vue&type=style&index=0&id=1034ccaa&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1034ccaa"]])

export default __exports__